import { Composition, staticFile } from "remotion";
import { Slideshow } from "./Slideshow";
import { calculateMetadata } from "./calculate-metadata/calculate-metadata";
import { schema } from "./calculate-metadata/schema";
import { useEffect, useState } from "react";

const promisedMarkdown = fetch(staticFile("slides.md")).then((res) =>
  res.text(),
);

export const RemotionRoot = () => {
  const [markdown, setMarkdown] = useState<string>("");

  useEffect(() => {
    promisedMarkdown.then(setMarkdown).catch(() => setMarkdown(""));
  }, []);

  return (
    markdown && (
      <Composition
        id="Main"
        component={Slideshow}
        defaultProps={{
          theme: "dracula",
          markdown,
          // calculateMetadata will fill these:
          slides: [],
          themeColors: {} as any,
        }}
        fps={30}
        height={1080}
        calculateMetadata={calculateMetadata}
        schema={schema}
      />
    )
  );
};
